export var BusinessLiveAccessDocumentType;
(function (BusinessLiveAccessDocumentType) {
    // Completed UAT / integration-test document uploaded by the business.
    BusinessLiveAccessDocumentType["Uat"] = "UAT";
    // Signed business agreement (MSA) uploaded by the business.
    BusinessLiveAccessDocumentType["BusinessAgreement"] = "BUSINESS_AGREEMENT";
    // Final, negotiated agreement copy uploaded by the admin (per business).
    BusinessLiveAccessDocumentType["FinalAgreement"] = "FINAL_AGREEMENT";
})(BusinessLiveAccessDocumentType || (BusinessLiveAccessDocumentType = {}));
//# sourceMappingURL=BusinessLiveAccessDocumentType.js.map